import { LocationDropdown } from "../LocationDropdown";
import { countryOptions, getStateOptions } from "../../utils/locationData";

export default function LocationFiltersEditor({
  locationFilters,
  setLocationFilters,
  layout = "horizontal",
  filterOptions = (options) => options,
  allowMultiple = true,
}) {
  const isVertical = layout === "vertical";
  const visibleFilters = allowMultiple
    ? locationFilters
    : locationFilters.slice(0, 1);

  return (
    <div className="space-y-3">
      {visibleFilters.map((filter, index) => (
        <div
          key={filter.id}
          className={
            isVertical
              ? "space-y-2 rounded-md border border-gray-100 bg-gray-50/50 p-3"
              : "flex flex-col items-start gap-4 md:flex-row"
          }
        >
          <div className={isVertical ? "w-full" : "w-full flex-shrink-0 md:w-[calc(50%-0.5rem)]"}>
            <LocationDropdown
              options={filterOptions(
                countryOptions.map((c) => ({
                  value: c.value,
                  label: c.label,
                }))
              )}
              selectedOption={filter.country}
              setSelectedOption={(country) => {
                setLocationFilters((prev) =>
                  prev.map((f, i) =>
                    i === index ? { ...f, country, state: null } : f
                  )
                );
              }}
              placeholder="Country"
            />
          </div>

          <div
            className={
              isVertical
                ? "w-full space-y-2"
                : "flex min-w-0 flex-1 gap-4"
            }
          >
            <div className={isVertical ? "w-full" : "min-w-[160px] flex-1"}>
              <div className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:text-sm">
                <input
                  type="text"
                  placeholder="City/Town"
                  value={filter.city}
                  onChange={(e) => {
                    setLocationFilters((prev) =>
                      prev.map((f, i) =>
                        i === index ? { ...f, city: e.target.value } : f
                      )
                    );
                  }}
                  className="block w-full border-0 bg-transparent p-0 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-0 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            {filter.country &&
              getStateOptions(filter.country.value).length > 0 && (
                <div className={isVertical ? "w-full" : "min-w-[160px] flex-1"}>
                  <LocationDropdown
                    options={filterOptions(
                      getStateOptions(filter.country.value).map((s) => ({
                        value: s.value,
                        label: s.label,
                      }))
                    )}
                    selectedOption={filter.state}
                    setSelectedOption={(state) => {
                      setLocationFilters((prev) =>
                        prev.map((f, i) =>
                          i === index ? { ...f, state } : f
                        )
                      );
                    }}
                    placeholder="State/Province"
                  />
                </div>
              )}
          </div>

          {allowMultiple ? (
            <div
              className={`flex items-center gap-2 ${
                isVertical ? "justify-end" : "w-10 flex-shrink-0 justify-end"
              } ${
                !isVertical &&
                index === locationFilters.length - 1 &&
                locationFilters.length > 1
                  ? "w-20"
                  : ""
              }`}
            >
              {index === locationFilters.length - 1 && (
                <button
                  type="button"
                  onClick={() => {
                    const newId =
                      Math.max(...locationFilters.map((f) => f.id), 0) + 1;
                    setLocationFilters((prev) => [
                      ...prev,
                      { id: newId, country: null, city: "", state: null },
                    ]);
                  }}
                  className="rounded-md p-2 text-indigo-600 transition-colors hover:bg-indigo-50"
                  title="Add location filter"
                >
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </button>
              )}

              {locationFilters.length > 1 && (
                <button
                  type="button"
                  onClick={() => {
                    setLocationFilters((prev) =>
                      prev.filter((_, i) => i !== index)
                    );
                  }}
                  className="rounded-md p-2 text-gray-400 transition-colors hover:bg-red-50 hover:text-red-600"
                  title="Remove location filter"
                >
                  <svg
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              )}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
